var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-info",class:{ 'user-info_is-master': _vm.isMaster }},[(_vm.user.hasChildren)?_c('i',{class:`mdi ${_vm.icon}`,on:{"click":_vm.toogleNode}}):_vm._e(),_c('p',{staticClass:"name-text",on:{"click":_vm.toogleNode}},[_vm._v(_vm._s(_vm.user.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }